import { render, staticRenderFns } from "./IlluProximite.vue?vue&type=template&id=2cd53fc0&"
import script from "./IlluProximite.vue?vue&type=script&lang=js&"
export * from "./IlluProximite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports